import { FC } from "react";
import { Atom, X } from "lucide-react";
import { useMobileMenu } from "@/contexts/MobileMenuProvider";
import { useAuthForm } from "@/contexts/AuthFormProvider";
import {Button} from "../ui/button";

interface MobileMenuProps {
}

const MobileMenu: FC<MobileMenuProps> = () => {
  const {setShowMenu} = useMobileMenu();
  const {closeForm, showLoginForm, showRegisterForm} = useAuthForm();
  return (
    <div className="w-full h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-black fixed top-0 left-0 z-[9999] overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="absolute top-20 left-20 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-20 w-80 h-80 bg-purple-500/5 rounded-full blur-3xl"></div>
      
      <div className="relative z-10 w-full h-screen flex flex-col">
        {/* Header with Logo and Close */}
        <div className="flex justify-between items-center p-4 sm:p-6">
          <img
            src="/images/logo-light.png"
            alt="logo"
            className="brightness-110 h-8 w-auto"
          />
          <Button
            loading={false}
            onClick={(_e) => setShowMenu(false)}
            className="p-2 bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-xl backdrop-blur-sm transition-all duration-300"
            aria-label="Close menu"
            title="Close menu"
          >
            <X className="w-5 h-5" />
          </Button>
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col justify-center px-6 sm:px-8">
          <div className="max-w-md mx-auto w-full space-y-8">
            {/* Navigation Links */}
            <div className="space-y-6">
              <a
                onClick={(_e) => {
                  setShowMenu(false);
                  closeForm();
                  const element = document.getElementById('features');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="block text-white text-2xl sm:text-3xl font-bold hover:text-blue-400 transition-colors duration-300 cursor-pointer"
                style={{ fontFamily: 'GilroyMedium' }}
              >
                Features
              </a>
              
              <a
                onClick={(_e) => {
                  setShowMenu(false);
                  closeForm();
                  const element = document.getElementById('pricing');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="block text-white text-2xl sm:text-3xl font-bold hover:text-blue-400 transition-colors duration-300 cursor-pointer"
                style={{ fontFamily: 'GilroyMedium' }}
              >
                Pricing
              </a>
            </div>

            {/* Auth Buttons */}
            <div className="space-y-4">
              <Button
                loading={false}
                className="w-full text-white text-lg font-bold py-4 bg-transparent hover:bg-white/10 border border-white/20 rounded-xl backdrop-blur-sm transition-all duration-300"
                style={{ fontFamily: 'GilroyMedium' }}
                onClick={(_e) => {
                  setShowMenu(false);
                  showLoginForm();
                }}
              >
                Login
              </Button>
              
              <Button
                loading={false}
                icon={<Atom className="w-5 h-5" />}
                onClick={(_e) => {
                  window.lintrk('track', { conversion_id: 23344122 });
                  setShowMenu(false);
                  showRegisterForm();
                }}
                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white font-bold hover:from-blue-700 hover:to-blue-800 py-4 text-lg rounded-xl transition-all duration-300"
                style={{
                  fontFamily: 'GilroyMedium',
                  WebkitFontSmoothing: 'antialiased',
                  MozOsxFontSmoothing: 'grayscale',
                  transform: 'translateZ(0)',
                  backfaceVisibility: 'hidden',
                  WebkitBackfaceVisibility: 'hidden'
                }}
              >
                Sign Up
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
